import Transactions from '../../components/Transactions'

export default function Index() {
	return <Transactions />
}
